import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReverseProspect from './components/ReverseProspect';

const reverseProspect = (props,{ t }) => (
  <Container>
    <ReverseProspect {...props} />
  </Container>
);

reverseProspect.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(reverseProspect);
